import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { CORSService } from './service/cORS.service';
import { DocumentService } from './service/document.service';
import { DocumentMetadataService } from './service/documentMetadata.service';
import { AwsService } from './service/aws.service';
import { IsAliveService } from './service/isAlive.service';
import { MetadataDefinitionService } from './service/metadataDefinition.service';

@NgModule({
	imports:      [],
	declarations: [],
	exports:      [],
	providers: [
		CORSService,
		DocumentService,
		AwsService,
		DocumentMetadataService,
		IsAliveService,
		MetadataDefinitionService ]
})
export class ApiModule {
	public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
		return {
			ngModule: ApiModule,
			providers: [ { provide: Configuration, useFactory: configurationFactory } ]
		};
	}

	constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
		if (parentModule) {
			throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
		}
		if (!http) {
			throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
		}
	}
}
